import { OverRideLocaleType } from "@/locales/locales-interface";

export const ruLocale: OverRideLocaleType = {
  DateOfSignature: "Дата подписания",
  DateOfForming: "Дата формирования",
  SelectLearningMaterials: "Выберите учебные материалы",
  Save: "Сохранить",
  Amount: "Сумма",
  Responsible: "Ответственный",
  Number: "№",
  Delete: "Удалить",
  DocumentInArchive: "Документ в архиве",
  NotSigned: "Не подписан",
  Price: "Стоимость",
  NotSelected: "Не выбрано",
  Contractor: "Контрагент",
  Contract: "Договор",
  Signed: "Подписан",
  Action: "Действие",
  Name: "Название",
  DriveUsedTotal: "Диск (Занято/Всего)",
  Head: "Руководитель",
  MaximumPasswordLength: "Максимальная длина пароля",
  ShouldAPasswordContainUppercaseLatinCharacters:
    "Должен ли пароль содержать заглавные латинские буквы",
  ShouldAPasswordContainNumbers: "Должен ли пароль содержать цифры",
  ShouldAPasswordContainLowercaseLatinCharacters:
    "Должен ли пароль содержать строчные латинские буквы",
  MinimumPasswordLength: "Минимальная длина пароля",
  DriveTitle: "Имя диска",
  Edit: "Редактировать",
  Size: "Размер",
  Login: "Логин",
  Company: "Компания",
  User: "Пользователь",
  Formed: "Сформирован",
  EnterAmountRUB: "Введите сумму, руб.",
  Payments: "Оплаты",
  AddPayment: "Добавить оплату",
  Actions: "Действия",
  Account: "Счет",
  EnterTheSumOfPaymentRUB: "Введите сумму оплаты, руб.",
  Cancel: "Отмена",
  Date: "Дата",
  Balance: "Остаток",
  PaidIn: "Поступило",
  EnterDirectionLearningTitle: "Введите название направления",
  Description: "Описание",
  EnterDescriptionOfDirectionLearning: "Введите описание направления",
  Apply: "Применить",
  Free: "Свободно %",
  Used: "Занято",
  Available: "Доступно",
  Files: "Файлы",
  Total: "Всего",
  SettlementAccount: "Расчетный счет",
  Website: "Сайт",
  FullName: "Имя",
  ShortName: "Сокращенное название",
  RussianClassificationOnObjectsOfAdministrativeDivisionOKATO: "ОКАТО",
  RussianClassificationOfEconomicActivitiesOKVED: "ОКВЭД",
  AddCommissionMember: "Добавить члена комиссии",
  Phones: "Телефоны",
  PatronymicName: "Отчество",
  CorrespondentAccount: "Корреспондентский счет",
  PositionOfHead: "Должность руководителя",
  BankIdentificationCodeBIC: "БИК",
  CompanyDetails: "Реквизиты",
  TaxRegistrationReasonCodeKPP: "КПП",
  SelectNewHeadOfCompany: "Выберите нового руководителя компании",
  TaxpayerIdentificationNumberTIN: "ИНН",
  RegisteredAddress: "Официальный адрес",
  RussianNationalClassifierOfBusinessesAndOrganizationsOKPO: "ОКПО",
  Settings: "Настройки",
  Position: "Должность",
  ActiveCompany: "Включена",
  Surname: "Фамилия",
  FullNameOfCompanysHead: "ФИО руководителя компании",
  TimeZone: "Часовой пояс",
  CommissionMembers: "Члены комиссии",
  ActualAddress: "Фактический адрес",
  EnterTheName: "Введите название",
  Bank: "Банк",
  ActsOnTheBasisOf: "Действует на основании",
  FullNameOfCompanysHeadInTheGenitive:
    "ФИО руководителя компании в родительном падеже",
  PrimaryStateRegistrationNumberPSRN: "ОГРН",
  HeadOfCompany: "Руководитель компании",
  CreateCompanyEmployee: "Создать сотрудника компании",
  EditUser: "Редактировать пользователя",
  DeleteUserFromCompany: "Удалить пользователя из компании",
  Phone: "Телефон",
  Commission: "Комиссия",
  AddEmployee: "Добавить сотрудника",
  NotAvailable: "Недоступно",
  UsersNotFound: "Пользователи не найдены",
  ImportOfUsers: "Импорт пользователей",
  Created: "Дата создания",
  Created_male: "Дата создания",
  InviteUsers: "Пригласить пользователей",
  Warning: "Предупреждение",
  ContactPhone: "Контактный номер телефона",
  Role: "Роль",
  Employee: "Сотрудник",
  Employees: "Сотрудники",
  FirstNameSurnameOrEmailatLeastCharacters:
    "Имя, фамилия или email (не менее 3 символов)",
  SeeMore: "Показать еще",
  AddUserInCompany: "Добавить пользователя в компанию",
  Confirm: "Подтвердить",
  DoYouReallyWantToRemoveAUserFromYourCompany:
    "Вы действительно хотите удалить пользователя из вашей компании?",
  Modified: "Изменено",
  PhoneNumber: "Номер телефона",
  Accountant: "Бухгалтер",
  LearningRequestManager: "Менеджер по заявкам",
  Teacher: "Методист",
  NumberOfUsersInTheContract: "Кол-во пользователей в договоре",
  AddFromLearningRequest: "Добавить из заявки",
  EnterYourPaymentOption: "Введите свой вариант оплаты",
  EnterManually: "Ввести вручную",
  PrepaymentOf: "Предоплата 50%",
  ContractorType: "Тип контрагента",
  Type: "Тип",
  FullPostpayment: "Полная постоплата",
  AllContracts: "Все договоры",
  LegalPerson: "Юридическое лицо",
  PhysicalPerson: "Физическое лицо",
  ContractAddendum: "Приложение",
  ContractAddendums: "Приложения",
  EnterContractNumber: "Введите № договора",
  FullPrepayment: "Полная предоплата",
  PaymentTerms: "Условия оплаты",
  AddFromLearningMaterials: "Добавить из учебных материалов",
  SelectContract: "Выберите договор",
  AmountRUB: "Сумма, руб.",
  Students: "Студенты",
  SourceOfPayment: "Источник",
  PriceRUB: "Стоимость, руб.",
  ViewAllStudents: "Показать всех студентов",
  Status: "Статус",
  StartTypingALearningRequestNumber: "Начните вводить № заявки",
  LearningMaterialManager: "Материал / Менеджер",
  ResultsNotFound: "Нет результатов",
  LearningRequest: "Заявка",
  Add: "Добавить",
  Back: "Вернуться",
  RecordedWebinar: "Запись",
  Webinar: "Вебинар",
  PriceForOneStudent: "Стоимость за одного студента",
  EnterUsersFirstNameSurnameAndEmail:
    "Введите имя, фамилию или email пользователя",
  Course: "Курс",
  SelectType: "Выберите тип",
  LearningMaterial: "Учебный материал",
  NotSpecified: "Не указан",
  KaluginaLyudmilaProkofievna: "Калугина Людмила Прокофьевна",
  CompanysFullName: "Полное название организации",
  EgDirector: "например, директор",
  Contacts: "Контакты",
  ShortCompanyName: "Сокращенное название организации",
  OfKaluginaLyudmilaProkofievna: "Калугиной Людмилы Прокофьевны",
  EgCompanyStatute: "например, устава",
  StudentsCitizenshipcountryCodeOnRussianClassificationOfCountriesOfTheWorldOKSM:
    "Гражданство получателя (код страны по ОКСМ)",
  EducationalInstitutionName: "Наименование учебного заведения",
  Comment: "Комментарий",
  DateOfIssueOfAHESPEDocumentDateOfIssueOfAHigherEducationSecondaryProfessionalEducationDocument:
    "Дата выдачи документа о ВО/СПО",
  Gender: "Пол",
  RegistrationAddress: "Адрес регистрации",
  SurnameIsStatedInADipHEDipSPESurnameIsStatedInADiplomaOfHigherEducationSecondaryProfessionalEducation:
    "Фамилия указанная в дипломе о ВО/СПО",
  DateOfBirth: "Дата рождения",
  RegistrationNumberOfAHESPEDocument: "Регистрационный № документа о ВО/СПО",
  PassportIssuedBy: "Кем выдан паспорт",
  SeriesOfAHESPEDocument: "Серия документа о ВО/СПО",
  FromTheEducationCenter: "Со стороны учебного центра",
  PassportSeries: "Серия паспорта",
  PassportNumber: "№ паспорта",
  DateOfPassportIssuance: "Когда выдан паспорт",
  IndividualInsuranceAccountNumberSNILS: "СНИЛС",
  HESPEDocumentNumber: "№ документа о ВО/СПО",
  LevelOfEducation: "Уровень образования",
  UserContactPerson: "Пользователь / Контактное лицо",
  ContactPerson: "Контактное лицо",
  ContractorResponsible: "Контрагент / Ответственный",
  ContractorsNameOrTINatLeastCharacters:
    "Название контрагента или ИНН (не менее 3 символов)",
  Select: "Выбрать",
  ContractorNotFound: "Контрагент не найден",
  ListOfFoundContactors: "Список найденных контрагентов",
  IfValidalityPeriodIsUnlimitedEnter:
    "Если срок действия бессрочный, то укажите 0",
  ProfessionQualificationName: "Наименование квалификации",
  FISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining:
    "ФИС ФРДО",
  FurtherEducationalProgram: "Дополнительная профессиональная программа",
  FinalDocument: "Итоговый документ",
  DocumentsValidityPeriodMonths: "Срок действия документа, мес.",
  Published: "Опубликовано",
  Enter: "Введите",
  IntegratedGroupsOfSpecialities: "Укрупненные группы специальностей",
  LearningDirection: "Направление",
  NumberOfHours: "Кол-во часов",
  RandomOrderOfLeaningCourse: "Свободное передвижение по курсу",
  FieldOfProfessionalActivity: "Область профессиональной деятельности",
  Title: "Название",
  NotAttachedLectures: "Нет прикрепленных лекций",
  DoYouReallyWantToDetachALectureFromThisCourse:
    "Вы действительно хотите открепить лекцию от этого курса?",
  Detach: "Открепить",
  Viewed: "Ознакомлен",
  EditCourse: "Редактировать курс",
  Lectures: "Лекции",
  UpdateDate: "Дата обновления",
  ModifiedDate: "Дата изменения",
  NameTeacher: "Название / Методист",
  Hours: "Часов",
  CreationDate: "Дата создания",
  NotFound: "Не найдены",
  LearnerProgress: "Журнал учета освоения материала",
  RegistrationDate: "Дата регистрации",
  StartDate: "Дата начала обучения",
  UserIsntAttached: "Пользователь не прикреплен",
  EnterFullName: "Введите ФИО",
  AddStudents: "Добавить студентов",
  NumberOfLessons: "Кол-во уроков",
  NotStudents: "Студентов нет",
  AtLeastCharacters: "Не менее 3 символов",
  IfYouRemoveAStudentFromTheCourseAllAssociatedTrainingDocumentsAreDeletedDeactivateAStudentForClosingAccess:
    "Eсли вы удалите студента из курса, то с ним также все зависимые учебные документы. Для закрытия доступа доступа используйте отключение.",
  Clear: "Очистить",
  OpenAccess: "Открыть доступ",
  IfAUserIsDeactivatedAccessToTheCoursesLearningMaterialsIsClosed:
    "Если выключено, то доступ к учебным материалам курса будет закрыт.",
  RegisteredTill: "Зарегистрирован по",
  NotStudentsInProgress: "Обучающихся нет",
  RegisteredFrom: "Зарегистрирован с",
  EmailFullName: "Email, ФИО",
  Email: "Email",
  SelectFile: "Выбрать файл",
  SelectedFile: "Выбранный файл",
  CopyFieldCodesInTheDocxDocumentBelowIsAnExampleOfFillingTheDocumentTemplateTokensAreHighlightedInYellowForClarityYouDontHaveToDoThat:
    "Скопируйте коды полей в документ docx. Ниже приведен пример заполнения шаблона документа. Токены выделены желтым для наглядности, вам так делать необязательно.",
  TemplateType: "Тип шаблона",
  DocumentTemplateTitle: "Название шаблона документов",
  File: "Файл",
  DocumentTemplateFile: "Файл шаблона",
  SelectTemplate: "Выберите шаблон",
  DownloadFile: "Скачать файл",
  CreateNew: "Создать новый",
  CreateNewTemplate: "Создать новый шаблон",
  Generate: "Сформировать",
  ActionsNotAvailable: "Действия недоступны",
  TemplateTitle: "Название шаблона",
  Tokens: "Токены",
  RepeatedTokens: "Повторяющиеся токены",
  SelectEntityTemplate: "Выберите сущность шаблона",
  AlwaysShowAFixedNumberOfCharacters:
    "Всегда показывать фиксированное кол-во символов",
  ForExampleUC: "Например УЦ-",
  StartingSequenceNumber: "Начальное значение",
  Prefix: "Префикс",
  Preview: "Предпросмотр",
  EnterNumberOfCharactersInANumber: "Введите кол-во символов в номере",
  Postfix: "Постфикс",
  StudentsInProgress: "Обучающиеся",
  SelectCourse: "Выберите курс",
  ReasonOfTestingKnowledge: "Причина проверки знаний",
  ThereAreNotStudentsInTheSelectedCourseOrATrainingProtocolHasAlreadyCreated:
    "В выбранном курсе нет слушателей или протокол уже составлен",
  ThereAreNotCommissionMembersInYourCompany:
    "В вашей компании нет членов комиссии.",
  Secretary: "Секретарь",
  Chairman: "Председатель",
  TrainingProtocolNumber: "№ протокола",
  CourseResponsible: "Курс/Ответственный",
  Updated: "Дата обновления",
  Practice: "Практика",
  Test: "Тест",
  Training: "Обучение",
  AccessesToSelectedCourseOnSelectedDateHaventBeenProvided:
    "По выбранному курсу на выбранную дату доступов к обучению выдано не было.",
  CompletionDate: "Дата завершения обучения",
  OrderNumber: "№ приказа",
  NoStudentsStartingToLearnACourse: "В курсе нет активных студентов",
  StudentInProgress: "Обучающийся",
  NotStudentsInProgressInTheCourse: "В курсе нет активных обучающихся",
  TestIsntAttached: "Тест Не прикреплен",
  PracticeAssignmentIsntAttached: "Не прикреплена",
  EditContract: "Редактировать договор",
  Order: "Приказ",
  DeleteCompletionOrder: "Удалить приказ об отчислении",
  AvailableStudentsInProgress: "Доступные обучающиеся",
  AvailableStudents: "Доступные студенты",
  DocumentIsArchived: "Документ находится в архиве",
  AllDelete: "Удалить все",
  Move: "Переместить",
  CuttingFiles: "Вырезанные файлы",
  Format: "Формат",
  PasteTheCopiedFilesInTheCurrentDirectory:
    "Вставить скопированные файлы в текущую дерикторию",
  Copy: "Копировать",
  DoYouReallyWantToDeleteTheseFiles:
    "Вы действительно хотите удалить эти файлы ()?",
  CopiedFiles: "Скопированные файлы",
  FilesAreNotFoundInThisDirectory: "В данной директории файлов не найдено",
  SearchEnterAtLeastCharacters: "Поиск, введите не менее трех символов",
  LastFiles: "Последние файлы",
  Rename: "Переименовать",
  EnterName: "Введите имя",
  More: "Еще",
  CopyLinkToAFile: "Скопировать ссылку на файл",
  DocumentPoweredBy: "document, powered by",
  MicrosoftOffice: "Microsoft Office",
  OfficeOnline: "Office Online",
  ThisIsAnEmbedded: "This is an embedded",
  CreateFolder: "Создать папку",
  FolderName: "Имя папки",
  UploadFiles: "Загрузить файлы",
  DragAndDropFileHere: "Перетащите файл сюда",
  FilesNotSelected: "Файлы не выбраны",
  AddFiles: "Добавить файлы",
  FileManager: "Файловый менеджер",
  DeleteLearningMaterial: "Удалить материал",
  View: "Посмотреть",
  FileName: "Имя файла",
  UploadingDate: "Дата загрузки",
  AddLearningMaterial: "Добавить материал",
  TheFederalBudget: "Федеральный бюджет",
  ExpiryDateinMonths: "Окончание срока действия (в мес.).",
  TrainingProtocol: "Протокол",
  EvidenceOfLoss: "Подтверждение утраты",
  PaidEducation: "Платное обучение",
  NotInEducationalOrganization: "Не в образовательной организации",
  Not: "Нет",
  TitleOfDiplomaThesis: "Название дипломной работы",
  RecipientsName: "Имя получателя",
  RecipientsSurname: "Фамилия получателя",
  FulltimeparttimeStudy: "Очно-заочная",
  ReferenceFromTheDepartmentOfInternalAffairs:
    "Справка из органов внутренних дел",
  RegistrationNumber: "Регистрационный №",
  Duplicate: "Дубликат",
  IssueDate: "Дата выдачи",
  ReferenceFromTheFireAuthorities: "Справка из органов пожарной охраны",
  PlaceOfInternship: "Место стажировки",
  LocalTraining: "Местное обучение",
  DuplicateSettings: "Настройки дубликата",
  FormOfReceivingEducationAtTheTimeOfTheEducationalRelationshipTermination:
    "Форма получения образования на момент прекращения образовательных отношений",
  DocumentNumberForModification: "№ документа для изменения",
  Search: "Поиск",
  Other: "Другое",
  FulltimeStudy: "Очная",
  FormNumber: "№ бланка",
  FormSeries: "Серия бланка",
  RegionalBudget: "Региональный бюджет",
  SourceOfFunding: "Источник финансирования обучения",
  InEducationalOrganization: "В образовательной организации",
  ParttimeStudy: "Заочная",
  AwardedQualificationLevelClassCategory:
    "Присвоенный квалификационный разряд, класс, категория",
  FormEducation: "Форма обучения",
  EvidenceOfDestroyingDocuments: "Подтверждение уничтожения",
  SelectTrainingProtocol: "Выберите протокол",
  Original: "Оригинал",
  ExchangeDueToFalseInformationProviding:
    "Обмен по причине наличия недостоверной информации",
  RecipientsPatronymic: "Отчество получателя",
  ExchangeDueToDamage: "Обмен по причине порчи",
  AnnouncementInTheNewspaper: "Объявление в газете",
  ExchangeConfirmation: "Подтверждение обмена",
  EnterIfADocumentsDurationPeriodIsUnlimited:
    "Укажите 0, если срок действия документа бессрочный.",
  EducationDocumentName: "Наименование документа об образовании",
  ValidTill: "Действует до",
  Issued: "Выдан",
  Student: "Студент",
  DownloadFISFRDOFederalInformationSystemTheFederalRegisterOfDataOnEducationDocumentsAndorAboutQualificationDocumentsOnTraining:
    "Выгрузка ФИС ФРДО",
  NotResults: "Результатов нет",
  InArchive: "В архиве",
  ResultsOnTheEnteredDataNotFound: "По введенным данным результатов не найдено",
  ThisActionCannotBeUndoneAreYouSureYouWantToDelete:
    "Это действие невозможно отменить, вы действительно хотите удалить?",
  MoveInArchive: "Переместить в архив",
  EnterMaskName: "Введите название маски",
  SelectNumbering: "Выбрать нумерацию",
  SorryResultsNotFound: "Извините, результатов не найдено.",
  SumUpTheResults: "Подвести итоги",
  FailedTest: "проваленных теста",
  Check: "Проверить",
  ViewMistakes: "Смотреть ошибки",
  CheckingAssignments: "Проверка заданий",
  PracticeAssignments: "практических заданий",
  Courses: "Курсы",
  TrainedStudentsForMonth: "Обучено слушателей за месяц",
  LearningRequests: "Заявки",
  Managers: "Менеджеры",
  CourseRating: "Рейтинг курсов",
  OverviewOn: "Сводка на",
  SalesForMonthPcs: "Продажи за месяц, шт",
  RevenueRUB: "Выручка, руб",
  FinancialReport: "Деньги",
  TeacherAccount: "Личный кабинет преподавателя",
  Learn: "Изучаю",
  NotLearningMaterials: "Материалов нет",
  Webinars: "Вебинары",
  NumberOfLectures: "Кол-во лекций",
  FinalTest: "Итоговый тест",
  DateAndTime: "Дата и время",
  Participants: "Участников",
  CompletedLearningRequests: "Выполнено заявок",
  AmountOnTheSignedCertificatesOfCompletedWorks: "Сумма подписанных актов",
  Billed: "Выставлено",
  CertificatesOfCompletedWorks: "Акты",
  Income: "Пришло, руб",
  BillsRUB: "Счета, руб",
  Bills: "Счета",
  AmountOnTheIssuedCertificatesOfCompletedWorks: "Сумма выставленных актов",
  Paid: "Оплачено",
  Debt: "Долг",
  ForSignature: "На подпись",
  CertificatesOfCompletedWorksRUB: "Акты, руб",
  GoToPayments: "Перейти к оплатам",
  ForYesterday: "за вчера",
  InProcessing: "В работе",
  Done: "Выполнено",
  WaitingForPrepayment: "Ожидание предоплаты",
  TrainingCompleted: "Обучение завершено",
  GoToLearningRequests: "Перейти к заявкам",
  DocumentsPrepared: "Документы готовы",
  NotProcessed: "Не обработаны",
  Contractors: "Контрагенты",
  LearningRequestIsFormedFrom: "Заявка сформирована с",
  LearningRequestIsFormedTill: "Заявка сформирована до",
  RecordedWebinars: "записи вебинаров",
  Unpublished: "Не опубликовано",
  ViewConductedWebinars: "Смотреть прошедшие",
  WebinarSchedule: "Расписание вебинаров",
  NotUpcomingWebinar: "предстоящих вебинаров нет.",
  Upgrades: "Обновления",
  AllowedDomains: "Разрешенные домены",
  NameDescription: "Название/Описание",
  AccessRights: "Права доступа",
  YouDontHaveTheGeneratedKeys: "У вас нет сгенерированных ключей",
  PermittedIP: "Разрешенные IP",
  DeleteKey: "Удалить ключ",
  PermittedAPI: "Разрешенные API",
  WidgetIsCreated: "Виджет создан",
  WebsiteAddress: "Адрес сайта",
  ShowDescription: "Показывать описание",
  EnterAColorInHEXFormat: "Введите цвет в формате HEX",
  ColorOfTheTypesOfLearningMaterials: "Цвет типов учебных материалов",
  WidgetContent: "Содержимое виджета",
  CommentToWebform: "Комментарий к веб-форме",
  ShowToplevelTitles: "Показывать заголовки верхнего уровня",
  NotificationAfterSuccessfulLearningRequestSending:
    "Уведомление после успешной отправки заявки",
  SelectALearningRequestManager: "Выберите менеджера по заявкам",
  BackgroundColor: "Цвет фона",
  YouAreAbleToCopyTheCodeOnlyNow: "Скопировать код вы сможете только сейчас.",
  ThisManagerWillBeResponsibleOnTheLearningRequest:
    "Этот менеджер будет ответственным по заявке",
  PasteTheCodeBelowIntoTheContainerOnYourWebsiteWhereYouWantToShowAListOfLearningMaterials:
    "Вставьте код ниже в контейнер на вашем сайте, где нужно показать список учебных материалов.",
  CopyWidgetCode: "Скопировать код виджета",
  MainButtonsColor: "Цвет основных кнопок",
  ColorOfAFontOfDirection: "Цвет шрифта направлений",
  ShowNumberOfHours: "Показывать кол-во часов",
  ColorOfCoursesNamePriceHours: "Цвет названия курсов, стоимости, часов",
  ShowPrice: "Показывать стоимость",
  Manager: "Менеджер",
  SelectTheLearningMaterialsForAddingToTheWebsiteSeveralWidgetsCanBeAddedOnTheDifferentPagesOfOneWebsite:
    "Выберите учебные материалы, которые нужно добавить на сайт. На одном сайте может быть несколько виджетов на разных страницах.",
  ExampleGooglecom: "Пример google.com",
  EnterHEXColor: "Введите HEX цвета",
  DeleteWidget: "Удалить виджет",
  EditWidget: "Редактировать виджет",
  SelectUsers: "Выбрать пользователей",
  SendInvitations: "Отправить приглашения",
  Useremail: "user.email",
  MaximumScore: "Максимум баллов",
  StartedCompleted: "Начато/Завершено",
  Result: "Результат",
  Duration: "Длительность",
  TestResult: "Результаты теста",
  SessionIsActive: "Сессия активна",
  TestSessionTime: "Время прохождения",
  SessionFrom: "Сессия от",
  Scored: "Набрано баллов",
  Opened: "Открыто",
  Completed: "Завершено",
  LecturesTest: "Тест лекции",
  FormedFrom: "Сформирована с",
  FormedTill: "Сформирована по",
  NumberLearningRequest: "№ заявки",
  EnterNumber: "Введите №",
  RUB: "0 руб",
  LearningRequestProfile: "Профайл заявки",
  DeleteFromList: "Удалить из списка",
  EnterNumberOfLearningRequest: "Введите № заявки",
  NumberOfStudentsLearningACourseNumberOfStudentsInProgress:
    "Кол-во обучающихся",
  ViewListOfTheStudents: "Посмотреть список студентов",
  ViewListOfTheStudentsLearningACourseViewListOfStudentsInProgress:
    "Посмотреть список обучающихся",
  NumberOfStudents: "Кол-во студентов",
  AddingStudents: "Добавление студентов",
  Events: "События",
  SelectAStatusOfTheLearningRequest:
    "Выберите статусы, на которые можно будет перенести заявку",
  TheFollowingStatuses: "Следующие статусы",
  SelectAll: "Выбрать все",
  Attach: "Прикрепить",
  ListOfAddedCourses: "Список добавленных курсов",
  ListOfAvailableCourses: "Список доступных курсов",
  SearchForAvailableCourses: "Поиск доступных курсов",
  CourseNameatLeastCharacters: "Название курса (не менее 3 символов)",
  EditCourseMaterial: "Редактировать материал лекции",
  CreateCourseMaterial: "Создать материал лекции",
  AdditionalLearningMaterials: "Дополнительные материалы",
  LectureText: "Текст лекции",
  Slides: "Слайды",
  Video: "Видео",
  Text: "Текст",
  PublicationSetting: "Настройка публикации",
  LectureSlides: "Слайды лекции",
  LecturePages: "Страницы лекции",
  EditLecture: "Редактировать лекцию",
  All: "Все",
  NotLectures: "Лекций нет",
  EditPage: "Редактировать страницу",
  CreateLecturePage: "Создать страницу лекции",
  LearningMaterials: "Учебные материалы",
  AdditionOfLearningMaterials: "Добавление материалов",
  Sales: "Продажи",
  ControlPanel: "Панель управления",
  Reports: "Отчеты",
  Logout: "Выход",
  LearningResults: "Контроль обучения",
  EducationalDocuments: "Учебные документы",
  Assessment: "Контроль знаний",
  NotUsers: "Пользователей нет",
  EmailOrFullName: "Email или ФИО",
  NotStarted: "Не начато",
  NotStarted_male: "Не начат",
  CompleteTraining: "Завершить обучение",
  PhoneNumberIsNotSpecified: "Телефон не указан",
  AvailableOnlyForCourses: "Доступно только для курсов",
  LearningRequestType: "Тип заявки",
  AddStudentInProgress: "Добавить обучающегося",
  RegisterUser: "Зарегистрировать пользователя",
  Register: "Зарегистрировать",
  SelectWebinar: "Выберите вебинар",
  Registration: "Регистрация",
  SelectLearningMaterialType: "Выберите тип материала",
  SelectRecordedWebinar: "Выберите запись",
  Users: "Пользователи",
  ListOfUsersInLearningRequest: "Список пользователей в заявке",
  AttachedFiles: "Прикрепленные файлы",
  WriteYourAnswer: "Напишите ваш ответ",
  Submit: "Отправить",
  AddFile: "Добавить файл",
  CoursePracticeAssignment: "Практическое задание по курсу",
  Unknown: "Неизвестно",
  Failed: "Не сдано",
  Assignment: "Задание",
  DeletedUser: "Удаленный пользователь",
  Passed: "Сдано",
  TeachersComment: "Комментарий проверяющего",
  AnswerIsSubmitted: "Решение отправлено",
  Answer: "Решение",
  UsersAnswer: "Ответ пользователя",
  Attached: "Прикреплен",
  AssignmentsConditions: "Условия задания",
  YouNeedToAddADirectLinkURLToAVideoShortLinksCouldntBeUsed:
    "Должна быть прямая ссылка на видео. Короткие ссылки не подойдут.",
  AddALinkToTheSourceOrSelectAFileFromTheList:
    "Укажите ссылку на ресурс или выберите файл из списка",
  Content: "Содержимое",
  ShowFiles: "Показать файлы",
  EditRecordedWebinar: "Редактировать запись",
  MainInformation: "Основная информация",
  Documents: "Документы",
  Education: "Образование",
  DeleteStudent: "Удалить студента",
  DateOfStudentsRegistration: "Дата регистрации студента",
  Upgrade: "Обновить",
  Create: "Создать",
  SelectTermType: "Выберите тип термина",
  SelectTest: "Выберите тест",
  AttachPracticeAssignment: "Прикрепить практическое задание",
  AttachTest: "Прикрепить тест",
  CourseDoesntIncludeAPracticeAssignment: "У курса нет практического задания",
  DontAttachAPracticeAssignment: "Не прикреплять практическое задание",
  AddQuestionsInNewTest: "Добавить вопросы в новый тест",
  Questions: "Вопросы",
  NumberOfQuestionsInTest: "Кол-во вопросов в тесте",
  NumberOfAttemptsToPassTestPerDay: "Попыток сдать тест в сутки",
  SetToShowAllQuestions: "Оставьте 0, чтобы показать все вопросы",
  MinNumberOfCorrectAnswersToPassTest: "Кол-во правильных ответов для зачёта",
  Active: "Включено",
  EnterForNoTimeLimits: "Задайте 0 если тест не ограничен по времени",
  EditingAndPublishing: "Редактирование и публикация",
  CommentsToAnswers: "Комментарии к ответам",
  DisplayQuestionsRandomly: "Выводить вопросы случайным образом",
  TestSessionTimeinMinutes: "Время на решение теста (в минутах)",
  SetForNoTimeLimits: "Оставьте 0, если тест не ограничен по времени",
  ShowAnswerComments: "Показывать комментарии к ответам",
  PracticeTest: "Тренировочное тестирование",
  RandomOrderOfQuestions: "Порядок вопросов",
  NumberOfAttemptsToPassTestInTotal: "Попыток сдать тест всего",
  AnswersReceived: "Получено ответов",
  Started: "Начато",
  Started_male: "Начат",
  Correct: "Правильных",
  QuestionNumber: "Задано вопросов",
  Incorrect: "Неправильных",
  Print: "Печать",
  TestResults: "Результаты тестирования",
  Next: "Дальше",
  Question: "Вопрос",
  StartTest: "Начать тест",
  EachAnswerShouldBeStartedOnANewLineAndWithOneAsterisk:
    "Каждый ответ должен начинаться с новой строчки и одной звездочки *",
  ToCommentOnTheAnswersAddTheSymbolOnALineEndOfAnswer:
    "Чтобы указать комментарий к ответу — добавьте в конце строки ответа символы ///",
  MarkEachNewQuestionWithThreeAsterisks:
    "Каждый новый вопрос должен начинаться с трех звездочек ***",
  ToAddANewParagraphToTheQuestionGoToANewLine:
    "Чтобы добавить новый абзац к вопросу — перейдите на новую строчку",
  CheckCorrectnessOfTheGeneratedQuestionsBeforeAdding:
    "Проверьте правильность сгенерированных вопросов перед добавлением",
  ToIdentifyTheCorrectAnswersAddAnAsteriskWithAPlus:
    "Чтобы указать верные ответы — укажите звездочку с плюсом *+",
  EditOrChangeExamplesOfQuestions:
    "Отредактируйте или замените примеры вопросов",
  Requirements: "Требования",
  SaveQuestions: "Сохранить вопросы",
  CommentToAnswer: "Комментарий к ответу",
  Answers: "Ответы",
  SaveQuestion: "Сохранить вопрос",
  AddAnswer: "Добавить ответ",
  EnterAnswer: "Введите ответ",
  AddNewQuestion: "Добавить по одному",
  BulkAdd: "Добавить массово",
  AddCopied: "Добавить скопированные",
  Sort: "Сортировать",
  ShowComments: "Показать комментарии",
  Sorting: "Изменить вес",
  RequiredMinCorrectAnswersToPassTest: "Ответов для зачёта",
  TotalAttempts: "Попыток всего",
  QuestionsInTest: "Вопросов в тесте",
  AttemptsPerDay: "Попыток в сутки",
  CopyAllQuestions: "Скопировать все вопросы",
  TestTitle: "Название теста",
  CopyALoginAccess: "Скопировать доступы для входа",
  Password: "Пароль",
  EducationalProgram: "Программа",
  EducationalProgramAndDocuments: "Программы и документы",
  Companies: "Компании",
  Document: "Документ",
  PostalAddress: "Почтовый адрес",
  CompanyName: "Место работы",
  AboutMe: "О себе",
  ListOfFoundUsers: "Список найденных пользователей",
  ListOfFoundStudents: "Список найденных студентов",
  FirstNameSurnameEmail: "Имя, фамилия, Email",
  SelectPhoto: "Выберите фото",
  ChangeAvailableSpace: "Изменить доступное место",
  PatronymicInDativeCase: "Отчество в дательном падеже",
  Male: "Мужской",
  ChangePassword: "Изменить пароль",
  ActiveUser: "Пользователь активен",
  EnterNewPasswordAgain: "Введите новый пароль еще раз",
  SurnameInDativeCase: "Фамилия в дательном падеже",
  ResetPassword: "Сменить пароль",
  MainData: "Основные данные",
  EnterOldPassword: "Введите старый пароль",
  TypeIfYouWantToChangePassword: "Укажите, если хотите изменить пароль",
  Female: "Женский",
  FirstNameInDativeCase: "Имя в дательном падеже",
  Photo: "Фото",
  EnterNewPassword: "Введите новый пароль",
  NotSelectedGender: "Пол не выбран",
  AccessForCompany: "Доступы для компании",
  EditCompanysUser: "Редактировать пользователя из компании",
  EditCertificateOfCompletedWorks: "Редактирование акта",
  Editing: "Редактирование",
  PriceFrom: "Стоимость от",
  FormingDateFrom: "Дата формирования с",
  EnterPrice: "Введите стоимость",
  SignedFrom: "Подписан с",
  CertificatesOfCompletedWorksNotFound: "Акты не найдены",
  SearchForNumber: "Поиск по №",
  FormationDateTill: "Дата формирования по",
  PriceTill: "Стоимость до",
  SignedTill: "Подписан до",
  Template: "Шаблоны",
  CertificateOfCompletedWorks: "Акт",
  ContractorphysicalPerson: "Контрагент (физическое лицо)",
  CompanysName: "Название компании",
  Profiles: "Профайлы",
  SearchForName: "Поиск по названию",
  CreateDirectionOfLearning: "Создать направление",
  DirectionsOfLearningList: "Список направлений",
  DirectionsOfLearning: "Направления обучения",
  NewLearningDirection: "Новое направление",
  CreateCompany: "Создать компанию",
  SelectPreset: "Выберите пресет",
  CreateUser: "Создать пользователя",
  SharingPersonalData: "6.4.Передача персональных данных",
  TheMinimumNecessaryDataProvidedByTheUsersForCommunicationNamepossiblyUseAFictitiousNameMobileNumberAndorEmailAddress:
    "предоставляемые Пользователями минимально необходимые данные для связи имя (возможно использование вымышленного), номер мобильного телефона и/или адрес Email;",
  TheUsersPersonalDataIsCollectedOnTheWebsiteByEnteringDataByTheUserOnHisOwnInitiativeAtTheTimeOfAppealingToTheWebsiteAdministrationOrTheWebsiteAccordingToTheUsersSettings:
    "6.2.1.Сбор персональных данных Пользователя осуществляется на Сайте при внесении их пользователем по своей инициативе на момент обращения к Администрации сайта либо к сайту, согласно настроек Пользователя.",
  ComplianceOfThePurposesOfPersonalDataProcessingWithThePurposesDefinedInAdvanceAndDeclaredUnderTheCollectionOfPersonalDataAndAlsoWithTheAuthorityOfTheWebsiteAdministration:
    "соответствия целей обработки персональных данных целям, заранее определенным и заявленным при сборе персональных данных, а также полномочиям Администрации Сайта;",
  TheAdministrationWebsiteTakesTechnicalOrganizationalAndLegalMeasuresToEnsureTheProtectionOfTheUsersPersonalDataFromUnauthorizedOrAccidentalAccessToThatDestructionModificationBlockingCopyingDisseminationAndAlsoFromOtherIllegalActions:
    "7.1.Администрация Сайта принимает технические и организационно-правовые меры в целях обеспечения защиты персональных данных Пользователя от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.",
  LimitationOfTheRules: "8.Ограничение действия Правил",
  OtherInformationAboutTheUsersProcessingByTheWebsiteAdministration:
    "5.2.Иная информация о Пользователях, обрабатываемая Администрацией Сайта.",
  GeneralRegulations: "1. Общие положения",
  TheAdministrationWebsiteDoesntTakeResponsibilityForTheActionsOfThirdPartiesWhoHaveGainedAccessToInformationAboutTheUserThroughUsingTheInternetAndWebsiteServicesAndForConsequencesOfUsageInformationThatIsInherentlyAvailableForAnyInternetUser:
    "8.2.Администрация Сайта не несет ответственности за действия третьих лиц, получивших в результате использования Интернета или Услуг Сайта доступ к информации о Пользователе и за последствия использования информации, которая, в силу природы Сайта, доступна любому пользователю сети Интернет.",
  TheRelationsConnectedToProcessingCollectionStorageDisseminationAndProtectionOfTheWebsiteUsersAreRegulatedByThisRegulationOtherOfficialDocumentsOfTheWebsiteAdministrationAndTheCurrentLegislationOfTheRussianFederation:
    "1.2.Отношения, связанные со сбором, хранением, распространением и защитой информации о пользователях Сайта, регулируются настоящим Положением, иными официальными документами Администрации Сайта и действующим законодательством Российской Федерации.",
  TheContentOfPersonalData: "5.Состав персональных данных",
  SharingUsersPersonalDataWithStateBodieslocalSelfgovernmentBodiesIsCarriedOutInAccordanceWithTheProcedureProvidedForByLaw:
    "6.4.3.Предоставление персональных данных Пользователей по запросу государственных органов (органов местного самоуправления) осуществляется в порядке, предусмотренном законодательством.",
  ProcessingInformationAboutUsers: "6.Обработка информации о пользователях",
  LawfulnessOfThePurposesAndTypesOfPersonalDataProcessing:
    "законности целей и способов обработки персональных данных;",
  ReceivedInformationAsAResultOfTheUsersActionsOnTheWebsite:
    "информация, полученная в результате действий Пользователя на Сайте;",
  PurposesOfProcessingInformation: "4.Цели обработки информации",
  InformationAutomaticallyReceivedWhenAccessingTheWebsiteUsingBookmarkscookies:
    "информация, автоматически получаемая при доступе к Сайту с использованием закладок (cookies);",
  DestructionOfUsersPersonalDataIsDestroyedAtTheWrittenRequestOfTheUserTheRequestMustContainIdentificationDataThatDirectlyIndicatesThatTheInformationBelongsToThisUser:
    "6.5.1.Персональные данные пользователя уничтожаются по письменной просьбе Пользователя. Просьба должна содержат идентификационные данные, которые прямо указывает на принадлежность информации данному Пользователю.",
  ConditionsAndPurposesOfProcessingPersonalData:
    "2.Условия и цели обработки персональных данных",
  DestructionOfPersonalData: "6.5.Уничтожение персональных данных",
  TheUserAgreesToTheTermsAndConditionsOfTheRegulationByRegisteringSendingMessagesApplicationsLeadsOtherMessagesUsingTheWebFormsAndWebsiteContactMeansUsingWebsiteAndItsServicesMustBeImmediatelyTerminatedIfTheUserDoesntAgreeWithTheTermsAndConditionsOfTheRegulationsTheUserHimselfherselfIsResponsibleForThis:
    "1.3.Регистрируясь, отправляя сообщения, заявки, лиды, иные послания с помощью средств и форм связи на Сайте, Пользователь выражает свое согласие с условиями Положения. В случае несогласия Пользователя с условиями Положения использование Сайта и его сервисов должно быть немедленно прекращено. Ответственность за это несет сам Пользователь.",
  PersonalDataIsNotSharedWithAnyPersonsExceptInTheCasesSpecifiedByThisRegulation:
    "6.4.1.Персональные данные Пользователей не передаются каким-либо лицам, за исключением случаев, прямо предусмотренных настоящим Положением.",
  StorageAndUsingOfPersonalData:
    "6.3.Хранение и использование персональных данных",
  PersonalDataProcessingIsCarriedOutOnTheBasisOfTheFollowingPrinciples:
    "6.1.Обработка персональных данных осуществляется на основе следующих принципов",
  TheProcedureOfImplementationAndChangingOfTheRegulation:
    "3.Порядок ввода в действие и изменения Положения",
  TheAdministrationWebsiteRecommendsToTheUsersTakeResponsibilityForSolutionToQuestionRegardingTheAmountOfInformationAboutThemselvesSharingFromTheWebsite:
    "8.3.Администрация Сайта рекомендует Пользователям ответственно подходить к решению вопроса об объеме информации о себе, передаваемой с Сайта.",
  TheWebsiteAdministrationProcessesInformationAboutTheUsersIncludingTheirPersonalDataForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwners:
    "4.1.Администрация Сайта осуществляет обработку информации о Пользователях, в том числе их персональных данных, в целях выполнения обязательств между Администрацией Сайта и Пользователем в рамках предоставления информации о деятельности и работе структурных подразделений владельцев Сайта.",
  InformationNecessaryForIdentificationOfTheUserForAccessToWebsiteServices:
    "информация, необходимая для идентификации Пользователя для доступа к сервисам сайта.",
  TheWebsiteAdministrationDoesntVerifyTheValidityOfReceivedcollectedInformationAboutTheUsersExceptingWhenTheAdministrationWebsiteHasToCompleteObligationsToTheUser:
    "1.4.Администрация Сайта не проверяет достоверность получаемой (собираемой) информации о Пользователях, за исключением случаев, когда такая проверка необходима в целях исполнения Администрацией Сайта обязательств перед Пользователем.",
  ApplicationsUsedByTheUsersOnTheWebsiteAreHostedAndMaintainedByThirdPartiesdevelopersWhoActIndependentlyOfTheWebsiteAdministrationAndDontActOnBehalfOrOnTheAuthorityOfTheWebsiteAdministrationTheUsersMustGetInformedThemselvesAboutTheRulesOfServiceDeliveryAndThePersonalDataProtectionPolicyOfSuchThirdPartiesdevelopersBeforeUsingTheRelevantApplications:
    "6.4.2.Приложения, используемые Пользователями на Сайте, размещаются и поддерживаются третьими лицами (разработчиками), которые действуют независимо от Администрации Сайта и не выступают от имени или по поручению Администрации Сайта. Пользователи обязаны самостоятельно ознакомиться с правилами оказания услуг и политикой защиты персональных данных таких третьих лиц (разработчиков) до начала использования соответствующих приложений.",
  PersonalDataProcessingByTheWebsiteAdministrationIsCarriedOutForCompletionObligationsBetweenTheWebsiteAdministrationAndTheUsersWithinAProvidingInformationAboutActivityAndWorkOfStructuralSubdivisionsOfTheWebsiteOwnersInAccordanceWithArticleOfFederalLawOfJulyFLAboutPersonalDataTheSeparateUsersConsentToTheProcessingOfThePersonalDataIsNotRequiredAccordingToASubparagraphClauseArticleOfThisLawTheWebsiteAdministrationHasTheRightForProcessingPersonalDataWithoutANotificationOfTheAuthorizedBodyOnTheProtectionOfTheRightsOfSubjectsOfPersonalData:
    "2.1.Администрация Сайта осуществляет обработку персональных данных пользователя в целях исполнения своих обязательств между Администрацией Сайта и Пользователем в рамках предоставления информации о деятельности и работе структурных подразделений владельцев Сайта. В силу статьи 6 Федерального закона от 27.07.2006 № 152-ФЗ О персональных данных отдельное согласие пользователя на обработку его персональных данных не требуется. В силу п.п. 2 п. 2 статьи 22 указанного закона Администрация Сайта вправе осуществлять обработку персональных данных без уведомления уполномоченного органа по защите прав субъектов персональных данных.",
  TheWebsiteAdministrationHasTheRightToMakeChangesToTheRegulationTheWebsiteAdministrationNotifiesTheUsersAboutTheRegulationsChangesByPostingTheNewVersionOnWebsiteAtThePermanentAddressInThisCaseThePreviousVersionsOfTheRegulationBecomeInvalid:
    "3.3.Администрация Сайта вправе вносить изменения в Положение. При внесении изменений в Положение уведомляет об этом пользователей путем размещения новой редакции на Сайте по постоянному адресу. Предыдущие редакции Положения при этом утрачивают силу.",
  TheUserAdditionallyOnHisOwnInitiativeProvidesOtherPersonalDataByUsingTheRelevantSectionsAndResourcesOfTheWebsite:
    "6.2.3.Остальные Персональные данные, предоставляются Пользователем дополнительно по собственной инициативе с использованием соответствующих разделов и ресурсов Сайта.",
  PersonalDataIsProvidedByTheUserVoluntarilyThatMeansAConsentToProcessingByTheWebsiteAdministrationAndIncludes:
    "5.1.Персональные данные предоставляются Пользователем добровольно, означают согласие на их обработку Администрацией Сайта и включают в себя",
  InAdditionTheWebsiteAdministrationProcessesOtherInformationAboutTheUsersThatIncludes:
    "Администрация Сайта обрабатывает также иную информацию о Пользователях, которая включает в себя",
  TheseRulesDoNotApplyToAThirdPartysActionsAndInternetResources:
    "8.1.Действие настоящих Правил не распространяется на действия и интернет-ресурсов третьих лиц.",
  ThisRegulationIsAnOfficialDocumentOfWebsiteAdministrationPostedOnThisWebsiteAndDefinesTheProcedureForTheProcessingAndProtectionOfPersonalDataOfTheWebsiteUsershereinafterTheUsersAndWebsiteServiceshereinafterTheWebsite:
    "1.1.Настоящее Положение является официальным документом Администрации сайта, на котором оно размещено и определяет порядок обработки и защиты информации о физических лицах, пользующихся услугами интернет-сайта (далее — Сайт) и его сервисов (далее — Пользователи).",
  ComplianceWithTheAmountAndCharacterOfProcessedPersonalDataTypesOfPersonalDataProcessingWithThePurposesOfPersonalDataProcessing:
    "соответствия объема и характера обрабатываемых персональных данных, способов обработки персональных данных целям обработки персональных данных;",
  Integrity: "добросовестности;",
  ThisRegulationComesIntoForceFromPostingOnWebsiteAndRemainInForceWithoutLimitOfTimeUntilReplacingItWithANewRegulation:
    "3.1.Положение вступает в силу с момента его размещения на Сайте и действует бессрочно, до замены его новым Положением.",
  MeasuresToProtectUserInformation:
    "7.Меры по защите информации о Пользователях",
  OtherDataincludingGenderAgeDateOfBirthAddressEtcIsProvidedByTheUserAtWillAndIfNecessarySuchDataForCommunicationWithTheUserAndActivitiesRelatedToDeliveryOfServiceOrProductsToTheUser:
    "иные данные (в том числе пол, возраст, дата рождения, адрес и т. д.) предоставляются Пользователем по желанию и в случае необходимости таких данных для связи с пользователем и осуществлением действий, связанных с предоставлением услуг или доставкой товаров Пользователю.",
  CollectionOfPersonalData: "6.2.Сбор персональных данных",
  PurposesOfProcessingPersonalDataIncludeReceivingInformationMailingsDocumentsAndMaterialsIncludingAdvertisingByTheUserProcessingUsersOrdersWhichAreIntendedToReceiveGoodsAndServicesUserConsultingSupport:
    "2.2.Цели обработки персональных данных включают в себя получение Пользователем информации, рассылок, документов и материалов, в том числе рекламного характера, обработка заказов Пользователя, направленных на получение товаров и услуг, консультационную поддержку Пользователя.",
  ReceivedInformationAsAResultOfOtherUsersActionsOnTheWebsite:
    "информация, полученная в результате действий других пользователей на Сайте;",
  TheCurrentVersionOfTheRegulationIsAPublicDocumentAvailableToAnyInternetUser:
    "3.2.Действующая редакция Положения, являющимся публичным документом, доступна любому пользователю сети Интернет.",
  PersonalDataStorageIsCarriedOutOnlyOnElectronicMediaAndProcessedUsingAutomatedSystemsExceptInCasesWhenNonautomatedProcessingOfPersonalDataIsNecessaryForComplyingWithTheLegalRequirements:
    "6.3.1.Персональные данные Пользователей хранятся исключительно на электронных носителях и обрабатываются с использованием автоматизированных систем, за исключением случаев, когда неавтоматизированная обработка персональных данных необходима в связи с исполнением требований законодательства.",
  StandardDataAutomaticallyReceivedByTheServerWhenAccessingTheWebsiteAndTheUsersFurtherActionsIPAddressOfTheHostTypeOfTheUsersOperatingSystemWebsitePagesVisitedByTheUser:
    "стандартные данные, автоматически получаемые сервером при доступе к Сайту и последующих действиях Пользователя (IP-адрес хоста, вид операционной системы пользователя, страницы Сайта, посещаемые пользователем);",
  ForgotPassword: "Забыли пароль?",
  Reset: "Восстановить",
  YourLoginOrEmail: "Ваш логин или Email",
  LoginOrEmail: "Логин или Email",
  PersonalDataProtectionRegulation: "Положение о защите персональных данных",
  LearningManagementSystem: "Система дистанционного обучения",
  EditBill: "Редактировать счет",
  AmountTill: "Сумма до",
  PaymentsRUB: "Оплаты, руб.",
  AmountFrom: "Сумма от",
  AllBills: "Все счета",
  BillsNotFound: "Счета не найдены",
  BillNumber: "№ счета",
  EnterBillNumber: "Введите № счета",
  ReceiptsOnAccount: "Оплаты по счету",
  BalanceRUB: "Остаток, руб.",
  RemainingDebt: "Оставшийся долг",
  TotalOfAllReceipts: "Сумма всех оплат",
  Bill: "Счет",
  PaidInRUB: "Поступило, руб.",
  DebtRUB: "Долг, руб.",
  EditCompany: "Редактировать компанию",
  NewCompany: "Новая компания",
  InformationAboutEducationalOrganization:
    "Сведения об образовательной организации",
  DocumentType: "Типы документа",
  NumberOfUsers: "Кол-во пользователей",
  AddCertificateOfCompletedWorks: "Добавить акт",
  LearningMaterialsNotSelected: "Учебные материалы не выбраны",
  AddBill: "Добавить счет",
  YouCantAddABillWithoutLearningMaterials:
    "Вы не можете добавить счет без учебных материалов",
  YouCantAddACertificateOfCompletedWorksWithoutLearningMaterials:
    "Вы не можете добавить акт без учебных материалов",
  NotAttachments: "Приложений нет",
  ContractorEditing: "Редактирование контрагента",
  NameTIN: "Название, ИНН",
  ContractorsNotFound: "Контрагенты не найдены",
  NewContractor: "Новый контрагент",
  CourseEditing: "Редактирование курса",
  AdditionalInformation: "Дополнительная информация",
  InformationAboutDocuments: "Информация о документах",
  CoursesNotFound: "Курсы не найдены",
  YouTeach: "Вы проводите",
  YouLearn: "Вы обучаетесь в",
  NewCourse: "Новый курс",
  NewSCORM: "Новый SCORM",
  NewCourseOfTraining: "Новый курс обучения",
  FileNotSelected: "Файл не выбран",
  UploadCourse: "Загрузить курс",
  Uncompress: "Распаковать",
  FolderTitle: "Название папки",
  NewSCORMCourse: "Новый SCORM курс",
  SelectSCORMArchive: "Выберите SCORM архив",
  DoYouReallyWantToCompleteTheTrainingInTheCurrentCourse:
    "Вы действительно хотите завершить обучение в текущем курсе?",
  PracticeAssignment: "Практическое задание",
  IfTheTestIsntAttachedAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial:
    "Если тест не прикреплен, то обучающийся не получит доступ к следующим материалам, пока не откроет текущий.",
  IfTheTestIsAttachedToTheLectureAStudentWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccefully:
    "Если к лекции прикреплено тестовое задание, то студент не получит доступ к следующим материалам, пока не пройдет успешно тест.",
  IfTheTestIsntAttachedAStudentWillNotHaveAccessToTheNextLearningMaterialsUntilHesheOpensTheCurrentMaterial:
    "Если тест не прикреплен, то студент не получит доступ к следующим материалам, пока не откроет текущий.",
  PracticeAssignmentIsCompleted: "Практическое задание выполнено",
  DocumentExpiryDateMonths: "Срок действия документа, мес",
  StartPracticeAssignment: "Сделать практическое задание",
  AttachTheLectureToTheCourse: "Прикрепить лекцию к курсу",
  NameOfTheFieldOfProfessionalActivity:
    "Наименование области профессиональной деятельности",
  TestSuccessfullyPassed: "Тест успешно пройден",
  AdditionalProfessionalProgram: "Дополнительные профессиональные программы",
  TableOfContents: "Содержание",
  IfTheTestIsAttachedToTheLectureAStudentInProgressWillNotHaveAccessToTheNextLearningMaterialsUntillHesheTakesTheTestSuccessfully:
    "Если к лекции прикреплено тестовое задание, то обучающийся не получит доступ к следующим материалам, пока не пройдет успешно тест.",
  NextLecture: "Следующий урок",
  Complete: "Завершить",
  DoYouReallyWantToCompleteTheCurrentLecture:
    "Вы уверены что хотите завершить текущий урок?",
  PreviousLecture: "Предыдущий урок",
  DocumentTemplateEditing: "Редактирование шаблона документов",
  NewDocumentTemplate: "Новый шаблон документа",
  EnterATitleOfTheDocumentTemplate: "Введите название шаблона",
  OrderOfEnrollment: "Приказ о зачислении",
  OrderOfCompletion: "Приказ об отчислении",
  GenerateFinalDocumentsForAllUsers:
    "Сформировать итоговые документы по всем пользователям",
  CreateFinalDocuments: "Создать итоговые документы",
  EditTrainingProtocol: "Редактировать протокол",
  EnterTrainingProtocolNumber: "Введите № протокола",
  TainingProtocolsNotFound: "Протоколы не найдены",
  NewTrainingProtocol: "Новый протокол",
  OrderOfEnrollmentEditing: "Редактирование приказа о зачислении",
  EnterOrderNumber: "Введите № приказа",
  OrdersOfEnrollment: "Приказы о зачислении",
  NewOrderOfEnrollment: "Новый приказ о зачислении",
  PleaseTryAgainOrContactTechnicalSupport:
    "Повторите еще раз или обратитесь в Службу технической поддержки.",
  SorrySomethingWentWrong: "Извините, произошла какая-то ошибка.",
  OrderOfCompletionEditing: "Редактирование приказа об отчислении",
  OrdersOfCompletion: "Приказы об отчислении",
  NewOrderOfCompletion: "Новый приказ об отчислении",
  EndDate: "Дата завершения обучения",
  DocumentNumber: "№ документа",
  RecipientsFullName: "ФИО получателя",
  Expires: "Истекает",
  RetrainingIsCarriedOutOnTheBasisOfAEducationalDocument:
    "Документ об образовании на основании которого переобучение",
  ToList: "К списку",
  DuplicateInformation: "Данные о дубликате",
  EditFinalDocument: "Редактировать итоговый документ",
  UnloadingParameters: "Параметры выгрузки",
  PageNumber: "номер страницы",
  FinalDocuments: "Итоговые документы",
  HowManyToGenerate: "по сколько формировать",
  NumberOfElementsForDownload: "Кол-во элементов для выгрузки",
  YouDontHaveFinalDocuments: "У вас нет итоговых документов",
  FISFRDOAPE: "ФИС ФРДО ДПО",
  IssuedTill: "Выдан по",
  FISFRDOPT: "ФИС ФРДО ПО",
  IssuedFrom: "Выдан с",
  SelectStudent: "Выберите слушателя",
  NewFinalDocument: "Новый итоговый документ",
  IMPORTANT: "ВАЖНО",
  SelectACategory: "Выберите категорию",
  AlsoBeSureYouHaveAFolder: "Так же убедитесь, что у вас есть папка",
  InCompanysFiles: "в файлах компании",
  ImportCourses: "Импорт курсов",
  WhenImportingYouShouldSpecifyTheFieldParameters:
    "При импорте необходимо указать параметры полей",
  EnterTheDomains: "Введите домены",
  EnterADomain: "Введите домен",
  CopyKey: "Скопировать ключ",
  Token: "Токен",
  GenerateKey: "Сгенерировать ключ",
  YouCanCopyATokenOnlyNow: "Скопировать токен вы сможете только сейчас.",
  APIKeyGenerating: "Генерация API Ключа",
  YourAPIKeyIsGenerated: "Ваш API ключ создан",
  EnterIPOneByOneOrSeveralSeparatedByCommas:
    "Введите IP (По одному или несколько через запятую)",
  EnterIP: "Введите IP",
  CreateAWidget: "Создать виджет",
  Integration: "Интеграции",
  Widget: "Виджет",
  NotificationForTheForm: "Уведомление для формы",
  NewWidgetOfCompany: "Новый виджет компании",
  EditCompanysWidget: "Редактировать виджет компании",
  DownloadTemplate: "Скачать шаблон",
  ImportCompanyUsersFromCsv: "Импорт пользователей компании из csv",
  RequirementsToAFile: "Требования к файлу",
  Import: "Импорт",
  TheUserTableShouldConsistOfColumnsInTheFollowingOrder:
    "Таблица пользователей должна состоять из колонок в следующем порядке",
  SpecifyTheDelimiter: "Укажите разделитель",
  TheFileEncodingShouldBeWindows: "Кодировка файла должна быть Windows-1251",
  ThePasswordMustBeAtLeastCharactersAndMustContainNumberUppercaseLetterLowercaseLetter:
    "Пароль должен быть не менее 8 символов и обязательно содержать 1 цифру, 1 заглавную букву, 1 строчную букву",
  TheFileEncodingShouldBeWindowsCyrillic:
    "Кодировка файла должна быть Windows-1251 (Кириллица)",
  MustBeFilled: "Обязательны для заполнения",
  EnterSurname: "Введите фамилию",
  AddToList: "Добавить в список",
  UserList: "Список пользователей",
  EnterPatronymic: "Введите отчество",
  CourseName: "Название курса",
  AllTrainingStatuses: "Не учитывать",
  ForExampleIvanov: "Например, Иванов",
  Successful: "Успешно",
  Unsuccessful: "Неуспешно",
  GeneralInformation: "Общая информация",
  AddToLearningRequest: "Добавить в заявку",
  RemoveFromLearningRequest: "Удалить из заявки",
  AddStatus: "Добавить статус",
  NewLecture: "Новая лекция",
  Lecture: "Лекция",
  TestPassedSuccessfully: "Тест успешно сдан",
  ToLectureList: "К списку лекций",
  EditingLearningRequest: "Редактирование заявки №",
  Invitations: "Приглашения",
  LearningRequestStatus: "Статус заявки",
  EditLearningRequest: "Редактировать заявку",
  NewLearningRequest: "Новая заявка",
  Version: "Версия",
  New: "Новые",
  Old: "Старые",
  ConfirmPassword: "Повторите пароль",
  EditingPracticeAssignment: "Редактирование практического задания",
  PracticeAssignmentsNotFound: "Практические задания не найдены",
  PendingReview: "Ждет проверки",
  SentForFinalization: "Отправлен на доработку",
  CreatePracticeAssignment: "Создать практическое задание",
  PracticeAssignmentResults: "Результаты практических заданий",
  NewPracticeAssignment: "Новое практическое задание",
  AssignmentToLearningMaterial: "Задание по материалу",
  WriteANewAnswer: "Напишите новый ответ",
  RequiredFinalization: "Требуется доработка",
  MyPracticeAssignmentResults: "Результаты моих практических заданий",
  YouHaventTakenAPracticeAssignmentOfThisCourse:
    "Вы не сдавали практическое задание этого курса",
  EditingRecordedWebinar: "Редактирование записи",
  NewRecordedWebinar: "Новая запись",
  RecordedWebinarNameatLeastCharacters: "Название записи (не менее 3 символов)",
  UsersWithAccessToARecordedWebinar: "Пользователи, имеющие доступ к записи",
  CloseAccessForUser: "Закрыть доступ пользователю",
  DocumentName: "Название документа",
  CreateDocumentType: "Создать тип документа",
  NewDocumentType: "Новый типа документа",
  TermName: "Название термина",
  TermType: "Тип термина",
  NewFISFRDO: "Новое ФИС ФРДО",
  EditingTest: "Редактирование теста",
  QuestionsUploading: "Загрузка вопросов",
  Tests: "Тесты",
  EnterTestName: "Введите название теста",
  TestsNotFound: "Тесты не найдены",
  NewTest: "Новый тест",
  SelectLecture: "Выберите лекцию",
  SelectStudentInProgress: "Выберите обучающегося",
  TrainingMaterialWasntSelectedInTheSearchFilterOrStudentsHaventTakenTheTests:
    "Не выбран учебный материал в фильтре или нет пройденных тестов",
  TestingDate: "Решен",
  NotLectureInSelectedCourse: "В выбранном курсе нет лекций",
  TestingFrom: "Решен с",
  ResultsOfTests: "Результаты тестов",
  TestType: "Тип теста",
  TestingTill: "Решен по",
  TryAgain: "Повторить",
  CompleteTheTest: "Завершить тестирование",
  TestToLearningMaterial: "Тест по материалу",
  EditingProfile: "Редактирование профиля",
  EditProfile: "Редактировать профиль",
  EditingWebinar: "Редактирование вебинара",
  NewWebinar: "Новый вебинар",
  WebinarEndDate: "Дата проведения",
  WebinarEndTime: "Время проведения",
  PriceMin: "Стоимость мин.",
  Max: "Макс.",
  Host: "Проводит",
  PublicationStatus: "Статус публикации",
  WebinarStartDate: "Дата проведения",
  PriceMax: "Стоимость макс.",
  Min: "Мин.",
  Hosted: "Проведено",
  WebinarNameatLeastCharacters: "Название вебинара (не менее 3 символов)",
  Online: "Идет",
  Planned: "Запланировано",
  EnableAWebinarRecording: "Разрешить запись вебинара",
  MaximumNumberOfStudents: "Максимальное кол-во студентов",
  SelectWebinarPlatform: "Выбрать площадку вебинара",
  UsersWithAccessToWebinar: "Пользователи, имеющие доступ к вебинару",
  LinkToTheSource: "Ссылка на ресурс",
  TurnOffPublicChatForUsers: "Отключить публичный чат для пользователей",
  Own: "Своя",
  StartTime: "Время начала",
  DisableAMicrophoneUsingForUsers:
    "Запретить пользователям использовать микрофон",
  Thirdparty: "Сторонняя",
  EndTime: "Время завершения",
  UserNotFound: "Пользователь не найден",
  DisableAWebcamUsingForUsers: "Запретить пользователям использовать вебкамеру",
  PasteTheLinkToTheSourceWhereTheWebinarWillBeHosted:
    "Вставьте ссылку на ресурс, где будет проходить вебинар",
  Completion: "Завершение",
  RecordsWillBeDeletedAfterDays: "Записи удаляются спустя 14 дней",
  Platform: "Площадка",
  TheRecordIsBeingPrepared: "Запись подготавливается",
  EditWebinar: "Редактировать вебинар",
  WebcamRecording: "Запись веб-камеры",
  ScreenRecording: "Запись экрана",
  Start: "Начало",
  CheckForRecordedWebinars: "Проверить наличие записей",
  RecordedWebinarsNotFound: "Записи вебинара не найдены",
  StudentsNumber: "Кол-во слушателей",
  WatchWebinar: "Посмотреть вебинар",
  FirstNameAddressEmailAndorPhoneAreProvidedByTheUserForFeedbackAndForStandardWorkOnTheWebsiteIsNotRequired:
    "6.2.2.Имя, адрес Email и/или телефон предоставляются Пользователем для осуществления обратной связи и для стандартной работы на Сайте не требуются.",
  Contracts: "Договоры",
  Export: "Экспорт",
  Yes: "Да",
  No: "Нет",
  Records: "Записи",
  Record: "Запись",
  CreateRecord: "Создать запись",
  FreeDiskSpace: "Свободное место",
  FullNameUser: "ФИО",
  Source: "Источник",
  Hide: "Скрыть",
  Show: "Показать",
  UserName: "Имя",
  PasswordsDoNotMatch: "Пароли не совпадают",
  Error: "Ошибка",
  TheInformationHasBeenSuccessfullyChanged: "Информация успешно изменена",
  UnknownError: "Неизвестная ошибка",
  DoNotAttachTheTest: "Не прикреплять тест",
  ChangesHaveBeenSuccessfullySaved: "Изменения успешно сохранены",
  AddQuestionsToTheTest: "Добавьте вопросы к тесту",
  TheQuestionCannotBeEmpty: "Вопрос не может быть пустым",
  TheAnswerChoiceCannotBeEmpty: "Вариант ответа не может быть пустым",
  AtLeastOneAnswerMustBeCorrect:
    "Хотя бы один вариант ответа должен быть верным",
  Learning: "Обучается",
  Pause: "Пауза",
  Success: "Успешно",
  Fail: "Не пройдено",
  Canceled: "Отменено",
  UseTheKeyboardArrowsToSelectDate:
    "Используйте стрелки клавиатуры для выбора даты",
  UserHasAlreadyCompletedTrainingIfYouNeedToRetrain:
    "Пользователь уже завершил обучение. Если нужно переобучить — добавьте человека в список еще раз.",
  TestFailed: "Тест провален",
  TheNumberOfCreatedTestQuestionsCannotBeLessThanTheActualNumberOfQuestionsInTheTest:
    "Кол-во созданных вопросов в тесте не может быть меньше фактического количества вопросов",
  ThisIsTheFirstParagraphOfTheQuestion: "*** Это первый абзац вопроса",
  SecondParagraphOfTheQuestion: "Второй абзац вопроса",
  AnswerDesc: "* Ответ",
  CorrectAnswerCommentOnTheAnswer: "*+ Верный ответ /// Комментарий к ответу",
  PushkinWasBornIn: "*** Пушкин родился в ...",
  YesterdayDesc: "*Вчера",
  Reply: "Ответить",
  ChooseAtLeastOneAnswer: "Выберите не менее одного варианта ответа",
  TimeExpired: "Время вышло",
  NotLimited: "Не ограничено",
  AQuestionCannotContainLessThanTwoAnswers:
    "Вопрос не может содержать меньше двух ответов",
  QuestionAdded: "Вопрос добавлен",
  SortingHasBeenChanged: "Сортировка изменена",
  NotAttached: "Не прикреплен",
  AccessDenied: "Запрещён",
  AccessGranted: "Разрешён",
  NotComplete: "Не завершено",
  CompletedUnsuccessfully: "Завершено неуспешно",
  Access: "Доступ",
  FirstName: "Имя",
  NoDateSpecified: "Дата не указана",
  PendingVerification: "Ожидает проверки",
  NotFilled: "Не заполнено",
  AlreadyCreated: "Уже созданные",
  NewContract: "Новый договор",
  TheTrainingCanBeCompletedByTheResponsibleTeacher:
    "Завершить обучение может ответственный методист",
  SomeRequiredFieldsAreNotFilledIn: "Некоторые обязательные поля не заполнены",
  SearchByEmail: "Поиск по Email",
  SuccessfullyDeleted: "Успешно удалено",
  ChooseAtLeastOneCourse: "Выберите как минимум один курс",
  ASlideCannotBeEmpty: "Слайд не может быть пустым",
  Untitled: "Без названия",
  ProfessionalEducation: "Профессиональное образование",
  AdditionalProfessionalEducation:
    "Дополнительное профессиональное образование",
  Indefinitely: "Бессрочно",
  InvitationsHaveBeenSuccessfullySent: "Приглашения успешно отправлены",
  Activated: "Активен",
  NotActivated: "Не активен",
  ShowMore: "Показать ещё",
  ThankYouYourLearningRequestWasSuccessfullyCreated:
    "Спасибо! Ваша заявка успешно создана!",
  IfAnythingGoesWrongOrYouHaveQuestions:
    "Если что-то идет не так или есть вопросы по курсу, звоните или пишите на наши контактные данные — мы поможем.",
  CodeCopiedSuccessfully: "Код успешно скопирован",
  InsertTheCodeBelowBeforeTheClosingTag:
    "Вставьте код ниже перед закрывающим тегом",
  onYourSite: "на вашем сайте",
  MostPopular: "Самые популярные",
  NoTest: "Тест отсутствует",
  NoPractice: "Практика отстуствует",
  TheTestHasNotStarted: "Тест не начат",
  FromTheArchive: "Из архива",
  NextMonth: "Следующий месяц",
  PreviousMonth: "Предыдущий месяц",
  NextYear: "Следующий год",
  PreviousYear: "Предыдущий год",
  Day: "День",
  IncorrectEmailFormat: "Неверный формат Email",
  AllValuesOfTheFieldsAtTheMomentWillBeSaved:
    "Сохранятся все значения полей на данный момент. Документ будет недоступен для редактирования",
  DoYouReallyWantToRemoveTheDocumentFromTheArchive:
    "Вы действительно хотите убрать документ из архива?",
  DoYouReallyWantToMoveTheDocumentToTheArchive:
    "Вы действительно хотите переместить документ в архив?",
  MinimumNumberOfCharactersEntered: "Минимальное кол-во введенных символов",
  ThePasswordMustConsistOfNumbersAndUpperAndLowerCaseLatinLetters:
    "Пароль должен состоять из цифр и латинских букв верхнего и нижнего регистра",
  ThisFieldIsRequired: "Это поле обязательно для заполнения",
  UnableToRetrieveUserInformation: "Невозможно получить данные пользователя",
  YouAnsweredCorrectlyTo: "Вы ответили верно на",
  outOf: "из",
  questionsOf: "вопросов",
  YouMustSelectAtLeastOneOption:
    "Вы должны выбрать хотя бы один вариант ответа",
  LectureTest: "Тест лекции",
  CourseTest: "Тест курса",
  LogIn: "Войти",
  AttachAStudentToTheUser: "Прикрепить к пользователю студента",
  UserPasswordSettings: "Настройки пароля пользователей",
  BasicInformation: "Основные сведения",
  StructureAndManagementBodies: "Структура и органы управления",
  EducationalStandards: "Образовательные стандарты",
  ManagementPedagogicalStaff:
    "Руководство. Педагогический (научно-педагогический) состав",
  MaterialAndTechnicalSupportAndEquipmentOfTheEducationalProcess:
    "Материально-техническое обеспечение и оснащенность образовательного процесса",
  ScholarshipsAndOtherTypesOfMaterialSupport:
    "Стипендии и иные виды материальной поддержки",
  FinancialAndEconomicActivities: "Финансово-хозяйственная деятельность",
  VacantPlacesForAdmission: "Вакантные места для приема (перевода)",
  AccessibleEnvironment: "Доступная среда",
  InternationalCooperation: "Международное сотрудничество",
  PaidEducationalServices: "Платные образовательные услуги",
  Citizenship: "Гражданство",
  Passport: "Паспорт",
  NewStudent: "Новый студент",
  YouCannotCreateInvoiceAmountGreaterThanContractAmount:
    "Вы не можете создать сумму счета больше, чем сумма договора",
  TheDiskVolumeCannotBeLessThanTheOccupiedSpace:
    "Объем диска не может быть меньше занятого пространства",
  EnterTheAmount: "Введите сумму",
  OneOrMoreFieldsAreEmpty: "Одно или несколько полей не заполнено",
  SelectStudents: "Выберите студентов",
  AtLeastOneUserMustBeSelected:
    "Необходимо выбрать хотя бы одного пользователя",
  GeneratePDF: "Сгенерировать PDF",
  TheLinkToChangeYourPasswordWasSentToTheEmail:
    "Ссылка на изменение пароля отправлена на почту",
  ImportedUsers: "Импортированные пользователи",
  CreateStudents: "Создать студентов",
  CreateLearningRequest: "Создать заявку",
  Lesson: "Урок",
  DocumentNumbering: "Нумерация документов",
  CreatingANumbering: "Создание нумерации",
  DocumentTemplates: "Шаблоны документов",
  TrainingProtocols: "Протоколы обучения",
  UploadCSVFileWithListOfYourUsersToTheFileManager:
    "Загрузите CSV-файл со списком ваших пользователей в файловый менеджер",
  IfTheUsernameAndPasswordFieldsAreNotFilled:
    "Если поля username и password не будут заполнены, то они автоматически сгенерируются",
  FastDocumentCreation: "Быстрое создание документов",
  MyPracticalAssignments: "Мои практические задания",
  MyTestResults: "Мои результаты тестов",
  ApplicationProfiles: "Группы статусов заявок",
  WaitingForPayment: "Ожидает оплаты",
  TrainingInProgress: "Идет обучение",
  CancelAll: "Отменить все",
  TheDateAreAsDayMonthYear:
    "Даты (birthday, educationDate и whenPassportIssued) указываются в виде День.Месяц.Год (Day.Month.Year)",
  TheGenderIsIndicatedByNumbers:
    "Пол обозначается цифрами: 1 - мужской, 0 - женский",
  UserSuccessfullyDisconnectedFromTheVideo:
    "Пользователь успешно откреплен от видео",
  UserSuccessfullyAddedToVideo: "Пользователь успешно добавлен к видео",
  RegistrationLinksWereSentToEmail:
    "Ссылки для регистрации отправлены на Email",
  TheUserIsNotAnActiveStudentInTheCourse:
    "Пользователь не является активным студентом курса",
  TheChangesYouMadeMayNotBeSaved:
    "Возможно, внесенные изменения не сохранятся!",
  MaximumNumberOfUsersWithAccessToTheWebinar:
    "Максимальное кол-во пользователей, имеющих доступ к вебинару",
  PleaseSpecifyTheMaximumNumberOfUsersWhoHaveAccessToTheWebinar:
    "Пожалуйста, укажите максимальное кол-во пользователей, имеющих доступ к вебинару",
  YouCanEnterTheWebinarRoomOnlyMinutesBeforeTheStart:
    "Зайти в вебинарную комнату можно только за 10 минут до начала",
  EntriesAreDeletedAfterDays: "Записи удаляются спустя 14 дней",
  TheFormedFieldIsRequired: "Поле 'Сформирован' обязательно для заполнения",
  SelectAFile: "Выберите файл",
  IncorrectDocumentFormatOnlyDocxIsAllowed:
    "Не верный формат документа, разрешен только docx",
  CompletedAndPassed: "Завершен успешно",
  Waived: "Отказался",
  Abandoned: "Заброшен",
  Satisfied: "Удовлетворительно",
  Paste: "Вставить",
  ImportContractorsFromCsv: "Импорт контрагенов из csv",
  ImportContractors: "Импорт контрагентов",
  ImportOfContractors: "Импорт контрагенов",
  TheContractorsTableShouldConsistOfColumnsInTheFollowingOrder:
    "Таблица контрагентов должна состоять из колонок в следующем порядке",
  UploadCSVFileWithListOfYourContractorsToTheFileManager:
    "Загрузите CSV-файл со списком ваших контрагенов в файловый менеджер",
  AskAllQuestionsInPracticeTest:
    "Задать все вопросы в тренировочном тестировании",
  DoNotLimitTheTimeOfPracticeTest:
    "Не ограничивать по времени тренировочное тестирование",
  ShowAnswersImmediatelyInPracticeTest:
    "Сразу показывать ответы в тренировочном тестировании",
  YouCanOnlyUseScvFile: "Необходимо использовать файлы формата csv",
  CopiedQuestions: "Вопросов скопировано",
  LoginLink: "Ссылка на вход",
  AccessCopied: "Доступы скопированы",
  docGenerate: "Сгенерировать документ",
  RussianLanguage: "Русский",
  EnglishLanguage: "Английский",
  Language: "Язык",
  WebinarNotStarted: "Не начат",
  Notice: "Уведомление",
  Ended: "Завершен",
  Month: "Месяц",
  FullYear: "Год (полностью)",
  Year: "Год",
  BindToDate: "Привязать к дате",
  UpdateFrequency: "Частота обновления",
  ThisAnswerIsCorrectYouDidntChooseTheCorrectAnswer:
    "Этот ответ правильный и он не был выбран",
  DomainMail: "Доменная почта",
  TrainingGroups: "Группы обучения",
  TrainingGroup: "Группа обучения",
  NewGroup: "Новая группа",
  TheStartDateOfTrainingOn: "Дата начала обучения по",
  TheStartDateOfTrainingFrom: "Дата начала обучения с",
  NoData: "Нет данных",
  Loading: "Загрузка",
  Home: "Главная",
  GenerateAccesses: "Сгенерировать доступы",
  Configuration: "Конфигурация",
  EmployeeDeleted: "Сотрудник удалён",
  DisabledCompany: "Выключена",
  ChooseStudents: "Выберите студентов",
  TokensList: "Список токенов",
  CopyToTheCurrentFolder: "Скопировать в текущую папку",
  MoveToTheCurrentFolder: "Переместить в текущую папку",
  DeleteSelectedFiles: "Удалить выбранные файлы",
  FormedContracts: "Сформированные договоры",
  FormedBills: "Сформированные счета",
  FormedActs: "Сформированные акты",
  FormedOrdersOfEnrollments: "Сформированные приказы о зачислении",
  FormedOrdersOfCompletions: "Сформированные приказы об отчислении",
  FormedTrainingProtocols: "Сформированные протоколы обучения",
  FormedFinalDocuments: "Сформированные итоговые документы",
  NumberOfApplicationsWithCurrentProfile:
    "Количество заявок с текущим профилем",
  Indefinite: "Бессрочно",
  AdditionalFeatures: "Дополнительные возможности",
  PageNotFound: "Страница не найдена",
  PageAccessDenied: "Доступ запрещен",
  NotDefined: "Не определено",
  Aborted: "Прервано",
  RegistrationExistMessage:
    "Пользователь с такими ФИО, датой рождения и СНИЛС существует:",
  Update: "Обновить",
  ShortNameFisFrdo: "ФИС ФРДО",
  AvailableSpacesForStudents: "Доступно мест для студентов",
  DirectorPositionGenitive:
    "Должность директора юридического лица в родительном падеже",
  DirectorNameInitials: "Фамилия и инициалы директора юридического лица",
  LastLogin: "Был в сети",
  RequiredData: "Необходимо заполнить данные",
  NewAgent: "Новый агент",
  Agents: "Агенты",
  Agent: "Агент",
  IsPercent: "Процент",
  CreatePaymentTerms: "Создать условие оплаты",
  Value: "Значение",
  AgentReports: "Отчет по агентам",
  PaidToTheAgent: "Оплачено агенту",
  PaidFrom: "Оплачено с",
  PaidTill: "Оплачено по",
  TermsOfPaymentToTheAgent: "Условия оплаты агенту",
  Received: "Поступила",
  Agency: "Агентские",
  ConditionList: "Условия оплаты",
  LicenseList: "Список лицензий",
  AmountOfWorkingHoursPerDay: "Количество рабочих часов в сутках",
  Calculate: "Посчитать",
  Weekends: "Выходные дни",
  Monday: "Понедельник",
  Tuesday: "Вторник",
  Wednesday: "Среда",
  Thursday: "Четверг",
  Friday: "Пятница",
  Saturday: "Суббота",
  Sunday: "Воскресенье",
  EditContractor: "Редактировать контрагента",
  Image: "Изображение",
  PracticeAssignmentPlural: "Практические задания",
  LockSettingsDisableCamera: "Запретить использовать камеру",
  LockSettingsDisableMicrophone: "Запретить использовать микрофон",
  LockSettingsDisablePublicChat: "Запретить использовать чат",
  ChangeView: "Изменить вид",
  ContractorCreate: "Создание контрагента",
  SuccessfullyCompleteTheProgressOfTheTraining:
    "Успешно завершать прогресс обучения при переводе заявки на статус «Обучение завершено»",
  InsertTable: "Вставить таблицу",
  AddColumnBefore: "Вставить столбец до",
  AddColumnAfter: "Вставить столбец после",
  DeleteColumn: "Удалить столбец",
  AddRowBefore: "Вставить строку до",
  AddRowAfter: "Вставить строку после",
  DeleteRow: "Удалить строку",
  DeleteTable: "Удалить таблицу",
  MergeCells: "Объеденить ячейки",
  SplitCell: "Разделить ячейки",
  ToggleHeaderColumn: "Переключить столбец заголовка",
  ToggleHeaderRow: "Переключить строку заголовка",
  ToggleHeaderCell: "Переключить ячейку заголовка",
  MergeOrSplit: "Объеденить/разбить",
  SetCellAttribute: "Установить атрибут ячейки",
  FixTables: "Исправить таблицу",
  GoToNextCell: "Перейти к следующей ячейке",
  GoToPreviousCell: "Перейти к предыдущей ячейке",
  ClearFinalDocumentExport:
    "Вы уверены, что хотите очистить дату выгрузки в ФИС ФРДО ?",
  Instructions: "Инструкции",
  Accounting: "Бухгалтерия",
  InProgress: "В процессе",
  CloseAccessToTrainingMaterials: "Закрыть доступ к материалам обучающего",
  RequestAmount: "Сумма заявок",
  ListOfLicenses: "Список лицензий",
  StudentDocuments: "Документы студента",
  YouCanOnlyAddStudentsToAGroupWithTheStatusLearning:
    "Добавить в группу можно только студентов на статусе «Обучается»",
  Send: "Отправить",
  Chats: "Чаты",
  NoMessages: "Сообщений нет",
  ToMyAccount: "К моему аккаунту",
  ToOtherAccounts: "К другим аккаунтам",
  UserDoesNotHaveAccessToYourAccount:
    "Пользователь не имеет доступа к вашему аккаунту",
  TheUserHasAccessToYourAccount: "Пользователь имеет доступ к вашему аккаунту",
  UserAccesses: "Доступы пользователя",
  MyAccesses: "Мои доступы",
  Provide: "Предоставить",
  Request: "Запросить",
  YouHaveAccessToTheUser: "У вас есть доступ к пользователю",
  YouDoNotHaveAccessToTheUser: "У вас нет доступ к пользователю",
  YouAreUnderADifferentAccountAndYouWillAutomaticallyReturnToYourAccountThrough:
    "Вы находитесь под другим аккаунтом. И автоматически вернетесь в свой аккаунт через",
  Read: "Прочитано",
  NotRead: "Не прочитано",
  Header: "Заголовок",
  Body: "Тело",
  Footer: "Подвал",
  NewDeal: "Новая заявка",
  PassingTheTestSuccessfully: "Успешная сдача теста",
  EnrollmentInTheCourse: "Зачисление на курс",
  BelowYouCanChangeTheMessagesSentToUsersOnTheSiteOrByEmailClearTheFieldsIfYouWantToLeaveTheDefaultNotificationText:
    "Ниже вы можете изменить сообщения, отправляемые пользователям на сайт или электронную почту. Очистите поля, если хотите оставить текст уведомлений по умолчанию.",
  AvailableTokens: "Доступные токены",
  MarkAsRead: "Пометить как прочитанные",
  NoNewNotifications: "Новых уведомлений нет",
  ViewAllNotifications: "Посмотреть все уведомления",
  Notifications: "Уведомления",
  IntoTheSystem: "В систему",
  EmailNotifications: "На почту",
  NotificationTemplates: "Шаблоны уведомлений",
  Agreed: "Дал согласие",
  DidNotAgree: "Не дал",
  YouAreGrantedAccessToTheAccount: "Вам предоставлен доступ к аккаунту",
  WantsAccessToYourAccount: "хочет получить доступ к вашему аккаунту",
  AccessToTheAccountGasBeenRequestedPleaseWait:
    "Доступ к аккаунту запрошен, ожидайте.",
  SystemSupport: "Тех. поддержка",
  CompanySupport: "Поддержка",
  WriteMessage: "Напишите сообщение",
  ChooseStaffMemberToAnswerGeneralStudentQuestions:
    "Выберите сотрудника, который будет отвечать на общие вопросы студентов. ",
  TheFileHasBeenImportedYouCanSeeTheNumbersInTheListOfStudentsInTheTrainingProtocol:
    "Файл импортирован. Номера можно посмотреть в списке студентов протокола обучения.",
  ImportSummary: "Сводка импорта",
  EmailFullNameSnilsOrPhone: "Email, ФИО, СНИЛС или Телефон",
  ExistStudentMessage: "Студент с такими ФИО и СНИЛС существует",
  RecentFiles: "Недавние файлы",
  OpenFullScreen: "Открыть на весь экран",
  TryTheNewInterfaceLabel: "Попробуйте новый интерфейс",
  TryTheNewInterfaceText:
    "Мы обновили дизайн и добавили много нового. В ближайшем будущем он станет основным. Если возникнут какие-то проблемы, то вы можете вернуться на предыдущий интерфейс повторно кликнув по иконке.",
  ChangeApplicationVersion: "Изменить версию приложения",
  CreateAtLeastOneFinalDocument: "Создайте как минимум один итоговый документ",
  RecordWebinar: "Записать вебинар",
  UpdateJournal: "Обновить журнал",
  Progress: "Прогресс",
  LessonBlock: "Блок уроков",
  ShowCorrectAnswers: "Показывать правильные ответы",
  NDS: "НДС",
  WithOutNDS: "Без НДС",
  AskQuestion: "Задать вопрос",
  FreeNavigationCourseLabelIcon:
    "Если выбрано «Нет», то студент сможет изучать материалы только по порядку. После сохранения настройка применится для всех уроков курса. Чтобы это изменить, используйте аналогичную настройку в самих уроках.",
  YouHaveNotBeenGrantedAccessToTheLessonStudy:
    "Вам не выдали доступ к изучению уроков",
  FreeMovementIsNotAllowedStudyThePreviousLessons:
    "Запрещено свободное передвижение. Изучите предыдущие уроки",
  LaborProtectionWorker: "Реестр охраны труда (работники)",
  LaborProtection: "Охрана труда",
  ShowDetails: "Показать подробности",
  Errors: "Ошибки",
  ErrorsWereFoundInTheFollowingLinesFixThemAndStartImportingAgain:
    "В следующих строках были найдены ошибки. Исправьте их и запустите импорт заново.",
  Line: "Строка",
  OrdersAlreadyCreated: "Уже созданные приказы",
  AddToTheOrder: "Добавить в приказ",
  YourCurrentVersion: "Ваша текущая версия",
  ScopeOfActivity: "Сфера деятельности",
  CountOfVariantsAndQuestions: "Кол-во вариантов/вопросов",
  CountOfVariants: "Кол-во вариантов",
  CountOfQuestions: "Кол-во вопросов",
  Variant: "Вариант",
  DifficultyLevel: "Уровень сложности",
  Easy: "Легкий",
  Medium: "Средний",
  Hard: "Сложный",
  AnyAnswerIsCorrect: "Любой ответ верный",
  SettingPointsForPassing: "Настройка баллов для прохождения",
  MinimumNumberOfCorrectAnswers: "Минимальное кол-во правильных ответов",
  InRandomOrder: "В случайном порядке",
  ByComplexity: "По сложности",
  ByVariants: "По списку вариантов",
  EditContent: "Редактировать содержимое",
  YouCanPractiseTakingTheTestByClickingOnThePracticeTest:
    "Вы можете попрактиковаться в сдаче тестирования, нажав на Тренировочное тестирование",
  ShowCorrectAnswersAfterPassing:
    "Показывать правильные ответы после прохождения",
  TestFormVariantsInfo:
    "Вариантов теста может быть несколько. При прохождении теста он выберется случайным образом. Если в этом нет необходимости, то создайте только один.",
  SortVariants: "Сортировать варианты",
  Alignment: "Выравнивание",
  Small: "Маленький",
  Large: "Большой",
  Fullscreen: "На полный экран",
  Left: "По левому краю",
  Right: "По правому краю",
  Center: "По центру",
  Regular: "Обычный",
  ChooseWhatHappensWhenTheRequestMovesToThisStatus:
    "Выберите что произойдет, когда заявка перейдет на этот статус",
  SelectTheStatusesToWhichTheApplicationCanBeTransferredFromThisStatus:
    "Выберите статусы, на которые можно будет перевести заявку после этого статуса",
  Schedule: "Расписание",
  Desk: "Экран",
  WebCamera: "Вебкамера",
  FullRecord: "Полная запись",
  NoRecordedWebinarsFound: "Записанные вебинары не найдены",
  CheckWebinarRecords: "Проверить наличие записей",
  NewSlide: "Новый слайд",
  NewVideo: "Новая запись",
  Imports: "Импорты",
  SelectACourseAndContractor: "Выберите курс и контрагента",
  TheFoundStudentsHaveSeveralContractorsPleaseSelectTheOneYouNeedAndContinueExporting:
    "У найденных студентов несколько контрагентов. Пожалуйста, выберите нужного и продолжите экспорт.",
  Minute: "Минута | Минуты | Минут",
  ToEvaluateTheStudentPracticeYouMustGoToTheDesiredSession:
    "Для оценки практики студента необходимо перейти в нужную сессию",
  AdvancedEditor: "Расширенный редактор",
  Positions: "Позиции",
  AgentPaymentAt: "Дата выплаты агенту",
  SuccessfullyRegistered: "Успешно зарегистрирован",
  StatusOfYourStudy: "Статус вашего обучения",
  StudyOfMaterials: "Изучение материалов",
  SpecifyTheSource: "Укажите источник",
  SelectStatusGroup: "Выберите группу статусов",
  TheStudentHasNotYetBeenGrantedAccessTraining:
    "Студенту ещё не выдан доступ к обучению",
  CompanyTimeSet: "Время устанавливается относительно часового пояса компании",
  ToTheTableOfContents: "К оглавлению",
  NoServerConnectionTryLater:
    "Нет соединения с сервером. Попробуйте ещё раз через несколько минут. Если ошибка продолжиться, то проверьте соединение",
  NotPublished: "Не опубликован",
  AccountAsLogin: "Аккаунт",
  GrantAccessByEmail: "Выдать доступ по email",
  ExpirationDate: "Дата окончания срока действия",
  ChangesYouMadeMayNotBeSaved: "Внесенные вами изменения могут не сохраниться",
  Director: "Директор",
  Exit: "Выход",
  GenerateXML: "Сгенерировать XML",
  FISFRDOunloaded: "ФИС ФРДО выгружено",
  FISFRDOunloadedFrom: "ФИС ФРДО выгружено c",
  FileTypeFISFRDO: "Тип файла ФИС ФРДО",
  HomePage: "Главная страница",
  ChangeUserName: "Изменить юзернейм",
  MyTraining: "Мое обучение",
};
